export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5094/api';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'not-configured';

export const config = {
  apiBaseUrl: API_BASE_URL,
  googleClientId: GOOGLE_CLIENT_ID,
};
